const scrollToError = errors => {
  if (errors) {
    const el = document.querySelector(`#${Object.keys(errors)[0]}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}

export default scrollToError
